import { useState } from 'react';
import { Search, ExternalLink, Trash2, Users, Lock } from 'lucide-react';

export const AttendeesTable = ({ users, tenantSlug, onDelete }) => {
  const [q, setQ] = useState('');
  const filtered = users.filter((u) =>
    [u.name, u.email, u.phone, u.gallery_id].some((v) => (v || '').toLowerCase().includes(q.toLowerCase()))
  );

  return (
    <div className="card" data-testid="attendees-card">
      <div className="px-6 py-5 border-b-2 border-line flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h2 className="h-display text-lg">Attendees</h2>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500 mt-1">{users.length} registered</p>
        </div>
        <div className="relative sm:w-80">
          <Search className="w-4 h-4 text-slate-500 absolute left-3 top-1/2 -translate-y-1/2" />
          <input data-testid="attendee-search-input" className="input !pl-10 !py-2.5" placeholder="Search name, email, gallery ID" value={q} onChange={(e) => setQ(e.target.value)} />
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full table-dark" data-testid="users-table">
          <thead>
            <tr>{['Name', 'Email', 'Phone', 'Gallery', 'Signature', 'Registered', ''].map((h) => <th key={h}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {filtered.map((user, index) => (
              <tr key={user.id} data-testid={`user-row-${index}`}>
                <td className="font-semibold text-white">{user.name}</td>
                <td>{user.email}</td>
                <td>{user.phone}</td>
                <td><code className="text-xs bg-ink border border-line text-cyan px-2 py-1">{user.gallery_id}</code></td>
                <td>
                  <span className={user.face_signature_active ? 'badge-success' : 'badge-muted'} data-testid={`signature-status-${index}`}>
                    {user.face_signature_active ? 'Active' : 'Purged'}
                  </span>
                </td>
                <td className="text-slate-400">{new Date(user.created_at).toLocaleDateString()}</td>
                <td>
                  <div className="flex gap-1.5 justify-end">
                    <button data-testid={`view-gallery-${index}-btn`} onClick={() => window.open(`/t/${tenantSlug}/gallery/${user.gallery_id}`, '_blank')} className="icon-btn" title="Open gallery">
                      <ExternalLink className="w-4 h-4" />
                    </button>
                    {user.is_demo ? (
                      <span className="icon-btn opacity-60 cursor-not-allowed" title="Protected demo guest — can't be deleted" data-testid={`protected-user-${index}`}><Lock className="w-4 h-4" /></span>
                    ) : (
                      <button data-testid={`delete-user-${index}-btn`} onClick={() => onDelete(user)} className="icon-btn hover:!border-red-500 hover:!text-red-400" title="Delete attendee">
                        <Trash2 className="w-4 h-4" />
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {filtered.length === 0 && (
          <div className="py-14 text-center" data-testid="no-attendees">
            <Users className="w-8 h-8 text-slate-600 mx-auto mb-3" />
            <p className="font-display font-bold uppercase tracking-wider text-sm text-slate-300">{q ? 'No attendees match your search' : 'No attendees yet'}</p>
            <p className="text-xs text-slate-500 mt-1">Share your public portal link so guests can register.</p>
          </div>
        )}
      </div>
    </div>
  );
};
